import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {Resource} from '../../../graphql/resources.datatypes';
import {gqlResource} from '../getResource.api';
import {ResourceTourRoleVars} from './updateResource.api';
import {CreditCardFee} from "../../../graphql/payments.datatypes";

export interface CreateResourceVars {
  data: {
    internal_name: string
    display_name: string
    t_and_c_url: string
    resource_type?: number | undefined
    disabled?: boolean
    parent_resource_id?: number
    has_dates?: boolean
    has_price?: boolean
    consumable?: boolean
    available_from?: string
    available_to?: string
    allow_manual_overbooking?: boolean
    show_on_invoice?: boolean
    description?: string
    locked?: boolean
    comms_email_address?: string
    max_additional_nights?: number
    max_nights_before?: number
    max_nights_after?: number
    guest_capacity?: number
    allow_multiple?: boolean
    rain_date_note?: string
    cancellation_policy?: string
    terms_and_conditions?: string
    contact_us_message?: string
    netsuite_tour_type?: string
    booking_tool_edit_cutoff?: string

    use_room_bank?: boolean
    room_bank_resource_id?: number

    tour_roles?: {
      create?: ResourceTourRoleVars[],
    }

    credit_card_fee?: {
      create?: CreditCardFee,
    }
  };
}

export interface CreateResourceData {
    createResource: Resource
}

export const CREATE_RESOURCE_MUTATION = gql`
    mutation createResource($data: CreateResourceInput!) {
        createResource(data: $data) {
            ${gqlResource}
        }
    }
`;

export const createResource = () => useMutation<CreateResourceData, CreateResourceVars>(
  CREATE_RESOURCE_MUTATION,
    {
        update: updateCacheByType('Resource'),
    }
);

export default createResource;
